import {
  addDomainLinkageUrl,
  getDomainLinkageDetailUrl,
  getDomainLinkagePaginatedListUrl,
  deleteDomainLinkageUrl,
  reactivateDomainLinkageUrl,
} from "./constants";
import base from "../middlewares/interceptors";

export const getDomainLinkagePaginatedList = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            // Skip empty array values
            return acc;
          } else {
            // Handle non-empty arrays - Let URLSearchParams handle encoding
            acc[key] = value.join(",");
          }
        } else if (value !== undefined && value !== null && value !== "") {
          // Handle non-array values - Let URLSearchParams handle encoding
          // Skip undefined, null, and empty string values
          acc[key] = value;
        }
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getDomainLinkagePaginatedListUrl}?${params.toString()}`,
    );

    // Return the items array from the paginated response, or empty array if not found
    return response?.data?.items || response?.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getDomainLinkageAllList = async ({
  payload,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    const params = new URLSearchParams({
      page: pageN,
      size: pageS,
      ...Object.entries(payload || {}).reduce((acc: any, [key, value]: any) => {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            return acc;
          } else {
            // Handle non-empty arrays - Let URLSearchParams handle encoding
            acc[key] = value.join(",");
          }
        } else if (value !== undefined && value !== null && value !== "") {
          // Handle non-array values - Let URLSearchParams handle encoding
          // Skip undefined, null, and empty string values
          acc[key] = value;
        }
        return acc;
      }, {}),
    });

    const response = await base.get(
      `${getDomainLinkagePaginatedListUrl}?${params.toString()}`,
    );

    // Return the items array from the paginated response, or empty array if not found
    return response?.data?.items || response?.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const addDomainLinkage = async (reqBody: any) => {
  try {
    const response = await base.post(addDomainLinkageUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
export const updateDomainLinkage = async (
  payload: any,
  domainLinkageId: any,
) => {
  try {
    const response = await base.put(
      `${addDomainLinkageUrl}/${domainLinkageId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getDomainLinkageDetail = async ({
  currentDomainLinkageId,
}: any) => {
  try {
    const response = await base.get(
      `${getDomainLinkageDetailUrl}?domain_linkage_filter_ids=${currentDomainLinkageId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Delete a domain linkage by ID
 * @param domainLinkageId - The ID of the domain linkage to delete
 * @returns Promise with deletion result
 */
export const deleteDomainLinkage = async (domainLinkageId: number) => {
  try {
    const response = await base.delete(
      `${deleteDomainLinkageUrl}/${domainLinkageId}`,
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error("Error deleting domain linkage:", error);
    throw error;
  }
};

/**
 * Reactivate a domain linkage by ID
 * @param domainLinkageId - The ID of the domain linkage to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateDomainLinkage = async (
  domainLinkageId: string | number,
) => {
  try {
    const response = await base.put(
      `${reactivateDomainLinkageUrl}/${domainLinkageId}/reactivate`,
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating domain linkage:", error);
    throw error;
  }
};
